// extracted by mini-css-extract-plugin
export default {"innerWrapper":"mB-z","tooltipWrapper":"nB-z","icon":"oB-z","tooltip":"pB-z","content":"qB-z"};